import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=666458ab"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=666458ab&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('666458ab')) {
      api.createRecord('666458ab', component.options)
    } else {
      api.reload('666458ab', component.options)
    }
    module.hot.accept("./sidebar.vue?vue&type=template&id=666458ab", function () {
      api.rerender('666458ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main-layout/sidebar.vue"
export default component.exports